import { CreateMedicineDto, Medicine } from "@/types/medicine";
import { BaseService, PaginatedResult } from "./base.service";
import { FilterDto } from "@/hooks/filterUtils";

class MedicinesService extends BaseService {
  constructor() {
    super('/medicine');
  }

  async getMedicines(dto: FilterDto): Promise<PaginatedResult<Medicine>> {
    return await this.post<PaginatedResult<Medicine>>('/getAll', dto);
  }

  async getMedicine(id: string): Promise<Medicine> {
    return await this.get<Medicine>(`/${id}`);
  }

  async createMedicine(data: CreateMedicineDto): Promise<Medicine> {
    return await this.post<Medicine>('', data);
  }

  async updateMedicine(id: string, data: Partial<Medicine>): Promise<Medicine> {
    return await this.put<Medicine>(`/${id}`, data);
  }

  async deleteMedicine(id: string): Promise<void> {
    return await this.delete(`/${id}`);
  }
}

export const medicinesService = new MedicinesService();
